export const VioletBlur = () => {
  return (
    <svg
      width="648"
      height="648"
      viewBox="0 0 648 648"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_1340_1699)">
        <circle cx="324" cy="324" r="130" fill="#4A25D5" />
      </g>
      <defs>
        <filter
          id="filter0_f_1340_1699"
          x="0"
          y="0"
          width="648"
          height="648"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="97"
            result="effect1_foregroundBlur_1340_1699"
          />
        </filter>
      </defs>
    </svg>
  );
};
